import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
} from "@angular/core";
import { Chart, ChartType } from "chart.js/auto";
import { DataStructureStatistics } from "../data-structure";
import "chartjs-plugin-datalabels";
import "chartjs-plugin-labels";

@Component({
    selector: "app-pie-chart",
    templateUrl: "./pie-chart.component.html",
    styleUrls: ["./pie-chart.component.scss"],
})
export class PieChartComponent implements OnInit {
    @Input() data: DataStructureStatistics;
    public chart: Chart;
    pieChartPlugins = [];

    constructor(
        private cdr: ChangeDetectorRef,
        private elementRef: ElementRef
    ) {}

    ngOnInit(): void {}

    ngOnChanges(): void {
        this.createChart();
    }

    private createChart(): void {
        if (!this.data) {
            console.warn("Data is not available to create the chart.");
            return;
        }

        // Obtain the parent div in the parent component IMPORTANT: the parent must have a div with class chart-container
        const container =
            this.elementRef.nativeElement.closest(".chart-container");
        if (!container) {
            console.error("Chart container element not found.");
            return;
        }

        let canvas_container = container.getElementsByClassName(
            "chart-container-div"
        )[0];
        canvas_container.innerHTML = "";

        // Create a canvas and assign to a canvas container
        const canvas = document.createElement("canvas");
        canvas.id = this.data.chartName; // Asignar el ID basado en el nombre del gráfico
        canvas_container.appendChild(canvas);

        // get context 2d
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            console.error("Failed to get 2D context from canvas element.");
            return;
        }

        this.chart = new Chart(ctx, {
            type: "pie" as ChartType,
            data: {
                labels: this.data.labels,
                datasets: this.data.datasets,
            },
            options: {
                plugins: {
                    legend: {
                        display: true,
                        labels: {
                            boxHeight: 15,
                        },
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                const dataset = context.dataset;
                                const label = context.label ? `${context.label}: ` : "";
                                const value = Number(
                                    Array.isArray(dataset.data)
                                        ? dataset.data[context.dataIndex]
                                        : context.raw
                                ) || 0;
                                const values = Array.isArray(dataset.data)
                                    ? dataset.data.map((item: any) => Number(item) || 0)
                                    : [];
                                const total = values.reduce((sum, item) => sum + item, 0);
                                const percentage = total > 0 ? ((value / total) * 100).toFixed(2) : "0.00";
                                return `${label}${value} (${percentage}%)`;
                            },
                        },
                    },
                },
            },
        });
    }
}
